import z from "zod";
import { DateTypeSchema } from "./core.schema";

export const AIHealthDetailsDtoSchema = z.object({
  version: z.string(),
  timestamp: DateTypeSchema,
  claudeModel: z.string(),
  elevenLabsModel: z.string(),
  thinkingBudget: z.number(),
  jobExpiryHours: z.number(),
});

export const AIJobStatusSchema = z.enum([
  "queued",
  "transcribing",
  "generating_minutes",
  "complete",
]);

export const AIJobStatusDtoSchema = z.object({
  jobId: z.string(),
  status: AIJobStatusSchema,
  progress: z.number(),
  updatedAt: DateTypeSchema,
});

export const AIAVDataDtoSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("url"), url: z.string() }),
  z.object({ type: z.literal("upload"), path: z.string() }),
]);
